module.exports = __webpack_public_path__ + "static/media/decrease-arrow.e0fb9d31.svg";